/* global React, window */
const { useState } = React;

// Paleta e tipografia do novo design de Home/Login (design system "Scolex"),
// isoladas das --vars globais de index.html pra não afetar o resto do
// wizard — só HomeMarketing e AccessGate (login) usam isso.
const HOME_COLORS = {
  teal900: "#12333A", teal800: "#164E5B", teal700: "#1C4E58", teal600: "#1C5555", teal500: "#22616C",
  teal400: "#2C8F9A", teal300: "#2E96A1", teal200: "#7FC4CC", teal100: "#BFE0E4", teal050: "#ECF7F8",
  green700: "#3F8722", green600: "#4FA32A", green100: "#D8E8D6", green050: "#EDF4E4",
  sun500: "#FCB316", sun400: "#F7CC1B",
  paper100: "#F5FAF9", paper200: "#EAF4F3",
  slate600: "#5E7378", slate400: "#9DB0B2", slate200: "#D6E2E3",
  textStrong: "#1C4E58", textBody: "#235C66",
  borderCard: "#E4EEEE", borderHairline: "#D6E2E3",
  heroGradient: "linear-gradient(105deg,#1C4E58 0%,#22616C 38%,#287A85 68%,#398F85 100%)",
  radiusCard: 18,
  shadowCard: "0 2px 10px rgba(18,51,58,.06), 0 12px 28px rgba(18,51,58,.05)",
  font: "'Fredoka','Poppins',sans-serif",
};
window.HOME_COLORS = HOME_COLORS;

// Editoras — mesmo nome/arquivo canônico usado em steps-curation.jsx.
// Renderizadas em containers de tamanho fixo (ver PublisherLogos) pra não
// ficarem desproporcionais entre si.
const PUBLISHERS = [
  { n: "Companhia das Letras", logo: "assets/editoras/companhia.png" },
  { n: "Penguin", logo: "assets/editoras/penguin.png" },
  { n: "Scholastic", logo: "assets/editoras/scholastic.png" },
  { n: "Pallas", logo: "assets/editoras/pallas.png" },
  { n: "Bloomsbury", logo: "assets/editoras/bloomsbury.png" },
  { n: "Pallas Mini", logo: "assets/editoras/pallasmini.png" },
  { n: "Global Editora", logo: "assets/editoras/global.png" },
  { n: "Grupo Editorial Record", logo: "assets/editoras/record.png" },
  { n: "Moderna Literatura", logo: "assets/editoras/moderna-literatura.png" },
  { n: "HarperCollins", logo: "assets/editoras/harpercollins.png" },
  { n: "Piraporiando", logo: "assets/editoras/piraporiando.png" },
  { n: "Savvas", logo: "assets/editoras/savvas.png" },
  { n: "Pearson", logo: "assets/editoras/pearson.png" },
  { n: "Girassol", logo: "assets/editoras/girassol.png" },
  { n: "Editora Globo", logo: "assets/editoras/globo.png" },
  { n: "FTD Educação", logo: "assets/editoras/ftd.png" },
];

// Container de tamanho fixo + object-fit:contain — cada logo mantém a
// proporção original (sem esticar) e todas ficam visualmente do mesmo
// tamanho, mesmo vindo de arquivos com dimensões bem diferentes.
function PublisherLogos({ variant = "flex", gap = 20 }) {
  if (variant === "grid") {
    return (
      <div style={{
        display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
        gap: "22px 28px", alignItems: "center", opacity: 0.82,
      }}>
        {PUBLISHERS.map((p) => (
          <img key={p.n} src={p.logo} alt={p.n} title={p.n} style={{ width: "100%", height: 42, objectFit: "contain", display: "block" }} />
        ))}
      </div>
    );
  }
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap, justifyContent: "center", alignItems: "center" }}>
      {PUBLISHERS.map((p) => (
        <div key={p.n} title={p.n} style={{ display: "flex", alignItems: "center", justifyContent: "center", height: 50, width: 130, flex: "none" }}>
          <img src={p.logo} alt={p.n} style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain", display: "block" }} />
        </div>
      ))}
    </div>
  );
}

// Faixas SX por série — mesma tabela oficial "Faixas de Classificação do
// SCOLEX por Série Equivalente" usada de verdade no wizard (ver
// SCOLEX_RANGE_BY_SERIES em shared.jsx). Títulos, SX e faixas (com P50)
// vieram prontos do designer (ajuste em cima do que a Scolist já tinha
// levantado pra Piraporiando) — não são mais um exemplo inventado aqui.
const HOME_SERIES = [
  { id: "2", label: "2º ano", faixa: "SX 157 a 422 · P50 306", livros: [
    { title: "Por que não existe flor preta?", meta: "Piraporiando · 40 páginas · educação antirracista", sx: "310", estoque: "em estoque", cover: "assets/covers/flor-preta.png" },
    { title: "Onde está o Bóris?", meta: "Piraporiando · 36 páginas · diversidade", sx: "315", estoque: "em estoque", cover: "assets/covers/onde-esta-o-boris.png" },
    { title: "Contos Piraporianos", meta: "Piraporiando · 36 páginas · contos", sx: "326", estoque: "em estoque", cover: "assets/covers/contos-piraporianos.png" },
  ] },
  { id: "3", label: "3º ano", faixa: "SX 283 a 489 · P50 399", livros: [
    { title: "Histórias do Velho Nestor", meta: "Piraporiando · 32 páginas · horror infantil", sx: "337", estoque: "em estoque", cover: "assets/covers/velho-nestor.png" },
    { title: "As Duas Bonecas Azuis", meta: "Piraporiando · 36 páginas · coragem", sx: "352", estoque: "em estoque", cover: "assets/covers/duas-bonecas-azuis.png" },
    { title: "Escada", meta: "Piraporiando · 32 páginas · afrofuturismo", sx: "390", estoque: "últimas unidades", cover: "assets/covers/escada.png" },
  ] },
];

function HomeContainer({ children, style }) {
  return <div style={{ maxWidth: 1180, margin: "0 auto", padding: "0 32px", ...style }}>{children}</div>;
}

function HomeEyebrow({ children, color }) {
  return (
    <div style={{
      font: `600 13px/1.2 ${HOME_COLORS.font}`,
      letterSpacing: "0.18em",
      textTransform: "uppercase",
      color: color || HOME_COLORS.teal300,
    }}>
      {children}
    </div>
  );
}

function HomeButton({ children, onClick, href, variant = "solid", size = "md", style }) {
  const sizes = {
    sm: { padding: "9px 18px", fontSize: 14 },
    md: { padding: "13px 26px", fontSize: 15 },
    lg: { padding: "16px 32px", fontSize: 16 },
  };
  const variants = {
    solid: { background: HOME_COLORS.sun400, color: HOME_COLORS.teal700, border: "none" },
    ghost: { background: "transparent", color: HOME_COLORS.teal700, border: `1.5px solid ${HOME_COLORS.teal700}` },
    ghostOnDark: { background: "transparent", color: "#fff", border: "1.5px solid rgba(255,255,255,.6)" },
  };
  const Tag = href ? "a" : "button";
  return (
    <Tag
      href={href}
      onClick={onClick}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 999,
        fontFamily: HOME_COLORS.font,
        fontWeight: 600,
        lineHeight: 1,
        textDecoration: "none",
        cursor: "pointer",
        whiteSpace: "nowrap",
        ...sizes[size],
        ...variants[variant],
        ...style,
      }}
    >
      {children}
    </Tag>
  );
}

function HomeCard({ children, style }) {
  return (
    <div style={{
      background: "#fff",
      border: `1px solid ${HOME_COLORS.borderCard}`,
      borderRadius: HOME_COLORS.radiusCard,
      boxShadow: HOME_COLORS.shadowCard,
      ...style,
    }}>
      {children}
    </div>
  );
}

function HomeListPreview() {
  const [serieId, setSerieId] = useState("3");
  const cur = HOME_SERIES.find((s) => s.id === serieId) || HOME_SERIES[1];

  return (
    <section id="lista" style={{ background: "#fff", padding: "80px 0" }}>
      <HomeContainer>
        <div style={{ textAlign: "center", maxWidth: 720, margin: "0 auto" }}>
          <HomeEyebrow>A lista pronta</HomeEyebrow>
          <h2 style={{ font: `600 38px/1.16 ${HOME_COLORS.font}`, color: HOME_COLORS.textStrong, margin: "14px 0 0" }}>
            Uma lista por série, no nível certo
          </h2>
          <p style={{ font: `400 20px/1.55 ${HOME_COLORS.font}`, color: HOME_COLORS.textBody, margin: "16px 0 0" }}>
            Estoque conferido e nível SX® em cada linha. Troque um título e a lista se ajusta na hora.
          </p>
        </div>

        <div style={{ display: "flex", justifyContent: "center", gap: 10, marginTop: 36, flexWrap: "wrap" }}>
          {HOME_SERIES.map((s) => {
            const active = s.id === cur.id;
            return (
              <button
                key={s.id}
                type="button"
                onClick={() => setSerieId(s.id)}
                style={{
                  border: `1px solid ${active ? HOME_COLORS.teal700 : HOME_COLORS.borderCard}`,
                  background: active ? HOME_COLORS.teal700 : "#fff",
                  color: active ? "#fff" : HOME_COLORS.teal700,
                  borderRadius: 999,
                  padding: "10px 22px",
                  font: `600 15px/1 ${HOME_COLORS.font}`,
                  cursor: "pointer",
                }}
              >
                {s.label}
              </button>
            );
          })}
        </div>

        <HomeCard style={{ marginTop: 28, overflow: "hidden" }}>
          <div style={{
            display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 16,
            padding: "22px 28px", background: HOME_COLORS.paper100, borderBottom: `1px solid ${HOME_COLORS.borderCard}`,
          }}>
            <div>
              <HomeEyebrow>Lista de literatura</HomeEyebrow>
              <div style={{ font: `600 22px/1.2 ${HOME_COLORS.font}`, color: HOME_COLORS.textStrong, marginTop: 6 }}>
                {cur.label}
              </div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ font: `400 13px/1 ${HOME_COLORS.font}`, color: HOME_COLORS.slate600 }}>Títulos na lista</div>
              <div style={{ font: `600 30px/1.1 ${HOME_COLORS.font}`, color: HOME_COLORS.textStrong }}>{cur.livros.length}</div>
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 22, padding: "14px 28px 4px", flexWrap: "wrap" }}>
            <div style={{ width: 52, flex: "none" }} />
            <div style={{ flex: "1 1 220px", font: `600 12px/1.2 ${HOME_COLORS.font}`, letterSpacing: "0.08em", textTransform: "uppercase", color: HOME_COLORS.slate600 }}>Livro</div>
            <div style={{ flex: "none", font: `600 12px/1.2 ${HOME_COLORS.font}`, letterSpacing: "0.08em", textTransform: "uppercase", color: HOME_COLORS.slate600 }}>Estoque</div>
            <div style={{ flex: "none", width: 48, textAlign: "center", font: `600 12px/1.2 ${HOME_COLORS.font}`, letterSpacing: "0.04em", textTransform: "uppercase", color: HOME_COLORS.slate600 }}>Índice Scolex</div>
          </div>

          {cur.livros.map((b, i) => (
            <div key={i} style={{
              display: "flex", alignItems: "center", gap: 22, padding: "18px 28px",
              borderBottom: `1px solid ${HOME_COLORS.paper200}`, flexWrap: "wrap",
            }}>
              <img src={b.cover} alt={b.title} style={{ width: 52, height: 74, objectFit: "cover", borderRadius: 4, boxShadow: "0 4px 10px rgba(18,51,58,.18)", flex: "none" }} />
              <div style={{ flex: "1 1 220px", minWidth: 0 }}>
                <div style={{ font: `600 17px/1.3 ${HOME_COLORS.font}`, color: HOME_COLORS.textStrong }}>{b.title}</div>
                <div style={{ font: `400 13px/1.4 ${HOME_COLORS.font}`, color: HOME_COLORS.slate600, marginTop: 4 }}>{b.meta}</div>
              </div>
              <span style={{
                display: "inline-flex", alignItems: "center", gap: 7, borderRadius: 999, padding: "6px 13px",
                background: HOME_COLORS.green050, color: HOME_COLORS.green700, font: `600 12px/1.2 ${HOME_COLORS.font}`, flex: "none",
              }}>
                ✓ {b.estoque}
              </span>
              <span style={{
                display: "inline-flex", alignItems: "center", justifyContent: "center", width: 48, height: 48, borderRadius: "50%",
                background: HOME_COLORS.teal400, color: "#fff", font: `600 14px/1 ${HOME_COLORS.font}`, flex: "none",
              }}>
                {b.sx}
              </span>
            </div>
          ))}

          <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 16, padding: "18px 28px" }}>
            <span style={{ font: `400 13px/1.4 ${HOME_COLORS.font}`, color: HOME_COLORS.slate600 }}>
              Curadoria Scolist® · disponibilidade confirmada com as editoras parceiras
            </span>
          </div>
        </HomeCard>
      </HomeContainer>
    </section>
  );
}

// Home institucional/marketing — aparece pra quem não está logado, antes da
// tela de login. onEnter leva pro AccessGate (login de escola).
function MarketingHome({ onEnter }) {
  const howItems = [
    { n: "1", title: "Histórico da escola", body: "O que já foi adotado, o que sobrou em estoque e o que as famílias reclamaram. Nada se repete sem intenção." },
    { n: "2", title: "Níveis SX® da turma", body: "Cada série tem uma faixa real de leitura. O Lex recomenda de 100 pontos abaixo a 50 pontos acima dela." },
    { n: "3", title: "Temas do ano letivo", body: "Autores brasileiros, meio ambiente, catálogo em PT / EN / ES. A coordenação escolhe os eixos e a curadoria segue." },
  ];

  const materiais = [
    { img: "assets/lex-curadoria.png", pos: "center top", title: "Literatura", body: "Curadoria por nível e por tema, com títulos das principais editoras do país." },
    { img: "assets/lex-didaticos.png", pos: "center top", title: "Didáticos", body: "Adoções por série e componente, com código e edição já conferidos." },
    { img: "assets/lex-papelaria-loja.jpeg", pos: "center 22%", title: "Papelaria", body: "O material do ano inteiro em quantidades reais, sem o item que ninguém usa." },
  ];

  return (
    <div style={{ background: "#fff", overflowX: "hidden", fontFamily: HOME_COLORS.font, color: HOME_COLORS.textBody }}>

      <header style={{ background: HOME_COLORS.heroGradient, position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", right: "-8%", top: "-30%", width: 680, height: 680, borderRadius: "50%", background: "rgba(255,255,255,.055)" }} />

        <nav style={{
          position: "relative", maxWidth: 1180, margin: "0 auto", padding: "22px 32px",
          display: "flex", alignItems: "center", justifyContent: "space-between", gap: 24, flexWrap: "wrap",
        }}>
          {/* Única logo Scolist da página, mantida grande e nítida — as demais
              (rodapé, seção final) foram removidas pra não repetir a marca sem
              necessidade. Placeholder pronto pro arquivo em alta resolução: é
              só trocar o src abaixo quando ele chegar. */}
          <img src="assets/scolist-wordmark-white.png" alt="Scolist" style={{ height: 46, width: "auto", display: "block" }} />
          <div style={{ display: "flex", alignItems: "center", gap: 28, flexWrap: "wrap" }}>
            <a href="#como" style={{ font: `500 15px/1 ${HOME_COLORS.font}`, color: "rgba(255,255,255,.85)", textDecoration: "none" }}>Como funciona</a>
            <a href="#lista" style={{ font: `500 15px/1 ${HOME_COLORS.font}`, color: "rgba(255,255,255,.85)", textDecoration: "none" }}>A lista</a>
            <a href="#familias" style={{ font: `500 15px/1 ${HOME_COLORS.font}`, color: "rgba(255,255,255,.85)", textDecoration: "none" }}>Para famílias</a>
            <button type="button" onClick={onEnter} style={{ font: `500 15px/1 ${HOME_COLORS.font}`, color: "rgba(255,255,255,.85)", background: "none", border: "none", cursor: "pointer", padding: 0 }}>Entrar</button>
            <HomeButton onClick={onEnter} size="sm">Montar minha lista</HomeButton>
          </div>
        </nav>

        <div style={{ position: "relative", maxWidth: 1180, margin: "0 auto", padding: "0 32px", display: "flex", flexWrap: "wrap", alignItems: "flex-end", gap: 24 }}>
          <div style={{ flex: "1 1 460px", padding: "36px 0 72px" }}>
            <div style={{
              display: "inline-flex", alignItems: "center", border: "1.5px solid rgba(191,224,228,.55)", borderRadius: 999,
              padding: "7px 16px", font: `600 13px/1 ${HOME_COLORS.font}`, letterSpacing: "0.06em", textTransform: "uppercase", color: "#fff",
            }}>
              Assistente de lista escolar
            </div>
            <h1 style={{ font: `600 56px/1.08 ${HOME_COLORS.font}`, letterSpacing: "-0.01em", color: "#fff", margin: "22px 0 0" }}>
              A lista do próximo<br />ano, pronta hoje
            </h1>
            <p style={{ font: `400 20px/1.55 ${HOME_COLORS.font}`, color: HOME_COLORS.teal100, margin: "20px 0 0", maxWidth: "48ch" }}>
              O <strong style={{ color: HOME_COLORS.sun400, fontWeight: 600 }}>Lex</strong> cruza o histórico da escola, os níveis <strong style={{ color: "#fff", fontWeight: 600 }}>SX®</strong> dos alunos e os temas do ano, e devolve a lista de literatura série por série, com estoque conferido e um link pronto para as famílias.
            </p>
            <div style={{ display: "flex", alignItems: "center", gap: 20, marginTop: 30, flexWrap: "wrap" }}>
              <HomeButton onClick={onEnter} size="lg">Montar minha lista</HomeButton>
              <span style={{ font: `600 15px/1.4 ${HOME_COLORS.font}`, color: "#fff" }}>volta às aulas · literatura, didáticos e papelaria</span>
            </div>
          </div>
          <div style={{ flex: "1 1 340px", position: "relative", display: "flex", justifyContent: "flex-end", alignItems: "flex-end", paddingBottom: 40 }}>
            <div style={{ position: "relative", width: "100%", maxWidth: 420, display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
              <img src="assets/lex-checklist.png" alt="Lex conferindo a lista escolar numa prancheta" style={{ width: "100%", maxWidth: 340, height: 440, objectFit: "contain", objectPosition: "bottom", display: "block" }} />
            </div>
          </div>
        </div>
      </header>

      <section style={{ background: "#fff", padding: "38px 0 10px" }}>
        <HomeContainer>
          <HomeEyebrow color={HOME_COLORS.slate600}>
            <div style={{ textAlign: "center" }}>Editoras no catálogo</div>
          </HomeEyebrow>
          <div style={{ marginTop: 24 }}>
            <PublisherLogos variant="grid" />
          </div>
        </HomeContainer>
      </section>

      <section id="como" style={{ background: HOME_COLORS.teal050, padding: "84px 0 88px", marginTop: 36 }}>
        <HomeContainer>
          <div style={{ textAlign: "center", maxWidth: 720, margin: "0 auto" }}>
            <HomeEyebrow>Como o Lex monta a lista</HomeEyebrow>
            <h2 style={{ font: `600 38px/1.16 ${HOME_COLORS.font}`, color: HOME_COLORS.textStrong, margin: "14px 0 0" }}>Três coisas que a escola já tem</h2>
            <p style={{ font: `400 20px/1.55 ${HOME_COLORS.font}`, color: HOME_COLORS.textBody, margin: "16px 0 0" }}>
              A lista não começa do zero. Ela começa do que aconteceu no ano passado, do nível de cada turma e do que a coordenação quer trabalhar.
            </p>
          </div>

          <div style={{ display: "flex", flexWrap: "wrap", gap: 24, marginTop: 48, alignItems: "stretch" }}>
            {howItems.map((it) => (
              <HomeCard key={it.n} style={{ flex: "1 1 300px", padding: 30 }}>
                <span style={{
                  display: "inline-flex", alignItems: "center", justifyContent: "center", width: 44, height: 44, borderRadius: "50%",
                  background: HOME_COLORS.teal400, color: "#fff", font: `600 20px/1 ${HOME_COLORS.font}`,
                }}>
                  {it.n}
                </span>
                <h3 style={{ font: `600 26px/1.35 ${HOME_COLORS.font}`, color: HOME_COLORS.textStrong, margin: "18px 0 0" }}>{it.title}</h3>
                <p style={{ font: `400 17px/1.55 ${HOME_COLORS.font}`, color: HOME_COLORS.textBody, margin: "10px 0 0" }}>{it.body}</p>
              </HomeCard>
            ))}
          </div>
        </HomeContainer>
      </section>

      <HomeListPreview />

      <section style={{ background: HOME_COLORS.green100, padding: "84px 0" }}>
        <HomeContainer>
          <div style={{ maxWidth: "62ch", margin: "0 auto", textAlign: "center" }}>
            <HomeEyebrow color={HOME_COLORS.teal700}>Uma lista só</HomeEyebrow>
            <h2 style={{ font: `600 38px/1.16 ${HOME_COLORS.font}`, color: HOME_COLORS.textStrong, marginTop: 12 }}>Não é só literatura</h2>
            <p style={{ font: `400 20px/1.55 ${HOME_COLORS.font}`, color: HOME_COLORS.teal700, margin: "14px 0 0" }}>
              Didáticos e papelaria entram na mesma lista, com o mesmo link e a mesma conferência de estoque.
            </p>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 24, marginTop: 48 }}>
            {materiais.map((m) => (
              <HomeCard key={m.title} style={{ flex: "1 1 300px", overflow: "hidden" }}>
                <img src={m.img} alt={m.title} style={{ width: "100%", height: 300, objectFit: "cover", objectPosition: m.pos, display: "block" }} />
                <div style={{ padding: "22px 26px 26px" }}>
                  <h3 style={{ font: `600 26px/1.35 ${HOME_COLORS.font}`, color: HOME_COLORS.textStrong, margin: 0 }}>{m.title}</h3>
                  <p style={{ font: `400 17px/1.55 ${HOME_COLORS.font}`, color: HOME_COLORS.textBody, margin: "8px 0 0" }}>{m.body}</p>
                </div>
              </HomeCard>
            ))}
          </div>
        </HomeContainer>
      </section>

      <section id="familias" style={{ background: "#fff", padding: "84px 0" }}>
        <HomeContainer style={{ display: "flex", flexWrap: "wrap", gap: 56, alignItems: "center" }}>
          <div style={{ flex: "1 1 380px" }}>
            <HomeEyebrow>Para as famílias</HomeEyebrow>
            <h2 style={{ font: `600 38px/1.16 ${HOME_COLORS.font}`, color: HOME_COLORS.textStrong, margin: "12px 0 0" }}>Um link, e a família resolve</h2>
            <p style={{ font: `400 20px/1.55 ${HOME_COLORS.font}`, color: HOME_COLORS.textBody, margin: "14px 0 0" }}>
              A escola compartilha um link. Cada família vê a lista da sua série, vê onde comprar e fecha tudo de uma vez no parceiro escolhido pela escola, sem planilha e sem PDFs por e-mail.
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 22 }}>
              <span style={{ font: `400 17px/1.55 ${HOME_COLORS.font}`, color: HOME_COLORS.textBody }}><strong style={{ color: HOME_COLORS.green600, fontWeight: 600 }}>✓</strong>&nbsp;&nbsp;Disponibilidade confirmada com as editoras e fabricantes parceiros</span>
              <span style={{ font: `400 17px/1.55 ${HOME_COLORS.font}`, color: HOME_COLORS.textBody }}><strong style={{ color: HOME_COLORS.green600, fontWeight: 600 }}>✓</strong>&nbsp;&nbsp;Entrega no endereço da família</span>
              <span style={{ font: `400 17px/1.55 ${HOME_COLORS.font}`, color: HOME_COLORS.textBody }}><strong style={{ color: HOME_COLORS.green600, fontWeight: 600 }}>✓</strong>&nbsp;&nbsp;5% da venda doado em livros para os bolsistas da escola</span>
            </div>
            <div style={{ marginTop: 28 }}>
              <HomeButton onClick={onEnter} variant="ghost">Ver a lista de exemplo</HomeButton>
            </div>
          </div>

          <div style={{ flex: "1 1 340px", background: HOME_COLORS.paper100, border: `1px solid ${HOME_COLORS.borderCard}`, borderRadius: HOME_COLORS.radiusCard, padding: 26 }}>
            <HomeEyebrow color={HOME_COLORS.slate600}>Onde comprar · 3º ano</HomeEyebrow>
            <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 16 }}>
              {[
                { nome: "Amazon Brasil", nota: "Entrega no endereço da família", slots: "2 de 3" },
                { nome: "Scolados", nota: "Parceiro oficial · lista completa", slots: "1 de 3", destaque: true },
                { nome: "Papelaria Tio João", nota: "Retirada em loja", slots: "1 de 3" },
              ].map((o) => (
                <div key={o.nome} style={{
                  display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, background: "#fff",
                  border: o.destaque ? `1.5px solid ${HOME_COLORS.teal300}` : `1px solid ${HOME_COLORS.borderCard}`,
                  borderRadius: 14, padding: "15px 18px", flexWrap: "wrap",
                }}>
                  <div>
                    <div style={{ font: `600 16px/1.2 ${HOME_COLORS.font}`, color: HOME_COLORS.textStrong }}>{o.nome}</div>
                    <div style={{ font: `400 13px/1.3 ${HOME_COLORS.font}`, color: HOME_COLORS.slate600, marginTop: 4 }}>{o.nota}</div>
                  </div>
                  <span style={{
                    display: "inline-flex", alignItems: "center", gap: 7, borderRadius: 999, padding: "7px 14px",
                    background: HOME_COLORS.paper100, color: HOME_COLORS.slate600, font: `600 13px/1.2 ${HOME_COLORS.font}`,
                  }}>
                    {o.slots}
                  </span>
                </div>
              ))}
            </div>
            <p style={{ font: `400 13px/1.5 ${HOME_COLORS.font}`, color: HOME_COLORS.slate600, margin: "16px 0 0", textAlign: "center" }}>
              A disponibilidade é conferida a cada consulta e pode variar conforme o estoque de cada parceiro.
            </p>
          </div>
        </HomeContainer>
      </section>

      <section id="comecar" style={{ background: HOME_COLORS.heroGradient, position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", right: "6%", top: "-40%", width: 560, height: 560, borderRadius: "50%", background: "rgba(255,255,255,.05)" }} />
        <HomeContainer style={{ position: "relative", display: "flex", flexWrap: "wrap", alignItems: "center", gap: 32 }}>
          <div style={{ flex: "1 1 420px", padding: "64px 0" }}>
            <h2 style={{ font: `600 44px/1.16 ${HOME_COLORS.font}`, color: "#fff", margin: 0 }}>Comece a lista do<br />próximo ano letivo</h2>
            <p style={{ font: `400 20px/1.55 ${HOME_COLORS.font}`, color: HOME_COLORS.teal100, margin: "14px 0 0", maxWidth: "46ch" }}>
              Leva uma tarde. O Lex faz as perguntas, a coordenação decide, e a lista sai pronta para as famílias.
            </p>
            <div style={{ display: "flex", alignItems: "center", gap: 20, marginTop: 28, flexWrap: "wrap" }}>
              <HomeButton onClick={onEnter} size="lg">Montar minha lista</HomeButton>
              <a
                href="https://wa.me/5511975055722?text=Quero%20saber%20mais%20sobre%20o%20Scolist"
                target="_blank"
                rel="noopener"
                style={{
                  display: "inline-flex", alignItems: "center", gap: 9, font: `600 15px/1 ${HOME_COLORS.font}`, color: "#fff",
                  border: "1.5px solid rgba(255,255,255,.5)", borderRadius: 999, padding: "14px 22px", textDecoration: "none",
                }}
              >
                Saber mais no WhatsApp
              </a>
            </div>
          </div>
          <div style={{ flex: "0 1 280px", display: "flex", justifyContent: "flex-end", alignItems: "flex-end", alignSelf: "stretch" }}>
            <img src="assets/lex1.png" alt="Lex" style={{ height: 300, maxWidth: "100%", objectFit: "contain", objectPosition: "bottom", display: "block" }} />
          </div>
        </HomeContainer>
      </section>

      <footer style={{ background: "#fff", padding: "40px 0 52px" }}>
        <HomeContainer style={{ display: "flex", flexWrap: "wrap", gap: 20, alignItems: "center", justifyContent: "space-between" }}>
          <span style={{ font: `600 16px/1 ${HOME_COLORS.font}`, color: HOME_COLORS.textStrong }}>Scolist</span>
          <span style={{ font: `400 13px/1.5 ${HOME_COLORS.font}`, color: HOME_COLORS.slate600 }}>
            assistente de lista escolar · movido pela escala Scolex® · catálogo em PT / EN / ES
          </span>
        </HomeContainer>
      </footer>

    </div>
  );
}
window.MarketingHome = MarketingHome;
